const localAPI = 'https://bousai-map.datacradle.jp/api'

const THRESHOLD = {
  11: '#f8b856',
  12: '#4194f6',
  13: '#ee7800',
  14: '#d7003a',
  15: '#622082',
}

const DOSYA_KEIKAI = '#d7003a'
const DOSYA_KIKEN = '#d7003a'

const SHINSUI_LEVEL = {
  11: { meter: '0～0.5ｍ未満', danger: '無' },
  12: { meter: '0.5～1.0ｍ未満', danger: '無' },
  13: { meter: '1.0～2.0ｍ未満', danger: '無' },
  14: { meter: '2.0～5.0ｍ未満', danger: '有' },
  15: { meter: '5.0ｍ以上', danger: '有' },
}

const markerCategory2Img = {
  'ため池': require('@/assets/marker/icon_tameike.png'),
  '自然災害伝承碑': require('@/assets/marker/icon_denshouhi.png'),
  '臨時給水所': require('@/assets/marker/icon_water.png'),
  'お風呂': require('@/assets/marker/icon_bath.png'),
  '仮設トイレ': require('@/assets/marker/icon_toilet.png'),
  '避難所': require('@/assets/marker/icon_hinanjyo.png'),
  'ガソリンスタンド': require('@/assets/marker/icon_h-gas.png'),
  'レンタカー': require('@/assets/marker/icon_h-car-rental.png'),
  '銀行': require('@/assets/marker/icon_h-bank.png'),
  '宿泊施設': require('@/assets/marker/icon_h-hotel.png'),
  '駅・バス停': require('@/assets/marker/icon_h-station.png'),
  'コインランドリー': require('@/assets/marker/icon_h-laundry.png'),
  'コンビニエンスストア': require('@/assets/marker/icon_h-convenience.png'),
  'スーパーマーケット': require('@/assets/marker/icon_h-supermarket.png'),
  '飲食店': require('@/assets/marker/icon_h-restaurant.png'),
  'ドラッグストア': require('@/assets/marker/icon_h-drag-store.png'),
  'ホームセンター': require('@/assets/marker/icon_h-home-center.png'),
  '衣料品店': require('@/assets/marker/icon_h-clothing-store.png'),
  '公園': require('@/assets/marker/icon_h-park.png'),
  '赤ちゃんの駅': require('@/assets/marker/icon_h-baby.png'),
  '福祉施設': require('@/assets/marker/icon_h-welfare.png'),
  '薬局': require('@/assets/marker/icon_h-pharmacy.png'),
  '病院': require('@/assets/marker/icon_h-hospital.png'),
  'default': require('@/assets/marker/icon_h-clothing-store.png')
}


const markerCategory2CssClass= {
  '臨時給水所': 'icon-water',
  'お風呂': 'icon-bath',
  '仮設トイレ': 'icon-toilet',
  '避難所': 'icon-hinanjyo',
  'ガソリンスタンド': 'color-gas',
  'レンタカー': 'color-car-rental',
  '銀行': 'color-bank',
  '宿泊施設': 'color-hotel',
  '駅・バス停': 'color-station',
  'コインランドリー': 'color-laundry',
  'コンビニエンスストア': 'color-convenience',
  'スーパーマーケット': 'color-supermarket',
  '飲食店': 'color-restaurant',
  'ドラッグストア': 'color-drag-store',
  'ホームセンター': 'color-home-center',
  '衣料品店': 'color-clothing-store',
  '公園': 'color-park',
  '赤ちゃんの駅': 'color-baby',
  '福祉施設': 'color-welfare',
  '薬局': 'color-pharmacy',
  '病院': 'color-hospital',
  'default': 'color-gas',
}

export default {
    localAPI,
    THRESHOLD,
    DOSYA_KEIKAI,
    DOSYA_KIKEN,
    SHINSUI_LEVEL,
    markerCategory2Img,
    markerCategory2CssClass
}
